export const WEEK_DAYS = [
  { key: 'MONDAY', label: 'Segunda', shortLabel: 'Seg' },
  { key: 'TUESDAY', label: 'Terça', shortLabel: 'Ter' },
  { key: 'WEDNESDAY', label: 'Quarta', shortLabel: 'Qua' },
  { key: 'THURSDAY', label: 'Quinta', shortLabel: 'Qui' },
  { key: 'FRIDAY', label: 'Sexta', shortLabel: 'Sex' },
  { key: 'SATURDAY', label: 'Sábado', shortLabel: 'Sáb' },
];

const formatIntervals = (intervals) => {
  const formatted = (intervals ?? [])
    .filter((interval) => interval.start && interval.end)
    .map((interval) => `${interval.start}–${interval.end}`);
  return formatted.length > 0 ? formatted.join(', ') : 'sem horário definido';
};

const formatDayRange = (group) => {
  const first = group[0].shortLabel;
  const last = group[group.length - 1].shortLabel;
  if (group.length === 1) return first;
  if (group.length === 2) return `${first} e ${last}`;
  return `${first} a ${last}`;
};

// Summarizes the working hours grouping consecutive days that share the same intervals,
// e.g. ["Seg a Sex: 08:00–12:00, 13:00–18:00", "Sáb: 08:00–12:00"].
export function formatWorkingHours(workingHours) {
  const intervalsByDay = new Map((workingHours ?? []).map((day) => [day.dayOfWeek, day.intervals]));

  const groups = [];
  WEEK_DAYS.forEach((day, index) => {
    if (!intervalsByDay.has(day.key)) return;
    const description = formatIntervals(intervalsByDay.get(day.key));
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.description === description && lastGroup.lastIndex === index - 1) {
      lastGroup.days.push(day);
      lastGroup.lastIndex = index;
    } else {
      groups.push({ days: [day], description, lastIndex: index });
    }
  });

  return groups.map((group) => `${formatDayRange(group.days)}: ${group.description}`);
}
